import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import Checkbox from '~/components/shared/CheckBox/CheckBox';
import { Body } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { updateForm } from '~/store/slices/loanOffer.slice';
import { RootState } from '~/store';
import { onChangeInputEvent } from '~/types/types';

const PersonalLiability = () => {
  const translate = useTranslate();
  const dispatch = useAppDispatch();

  const { form } = useSelector((state: RootState) => state.loanOffer);

  const onChange = (event: onChangeInputEvent) => {
    const { checked } = event.target;
    dispatch(updateForm({ personalLiabilityIsAgreed: checked }));
    dispatch(
      pushToGtmLoanAction({
        actionName: 'personal_liability_change',
        stepActionNumber: 0.2,
      })
    );
  };

  return (
    <Checkbox
      checked={form.personalLiabilityIsAgreed}
      dataCy="liability_consent_checkbox"
      name="personalLiabilityIsAgreed"
      onChange={onChange}
      validationType="Required"
    >
      <Body size="sm">{translate('OnboardingOffer.LiabilityConsent')}</Body>
    </Checkbox>
  );
};

export default PersonalLiability;
